module.exports = _.cloneDeepWith;